import { useEffect, useState } from 'react'
import { ICourse, IStatus, IVisibility } from '../../../models/course'
import { IRootState } from '@/redux/types'
import { useSelector } from 'react-redux'

function useCourseState(STATUS: IStatus[], VISIBILITY: IVisibility[]) {
  const { course_selected } = useSelector((state: IRootState) => state.course)
  const [courseState, setCourseState] = useState<ICourse>({
    id: null,
    brand: null,
    line: null,
    coursetype: null,
    title: '',
    duration: 0,
    description: '',
    leaded: '',
    requirements: '',
    responsibles: [],
    file_image: null,
    imagePreview: null,
    video_url: '',
    highlight: 0,
    visibility: VISIBILITY[0],
    status: STATUS[2],
    countries: [],
    languages: [],
    role: []
  })

  useEffect(() => {
    if (course_selected != null) {
      const imageUrl = course_selected.image_url || ''
      const imageName = imageUrl.substring(imageUrl.lastIndexOf('/') + 1)

      setCourseState({
        id: course_selected.id,
        brand: course_selected.brand,
        line: course_selected.line,
        coursetype: course_selected.coursetype,
        title: course_selected.title,
        duration: course_selected.duration,
        description: course_selected.description,
        leaded: course_selected.leaded,
        requirements: course_selected.requirements,
        responsibles:
          course_selected.responsibles.length > 0
            ? course_selected.responsibles.map((responsible: any) => {
                return responsible.id
              })
            : course_selected.user_id !== null
              ? [course_selected.user_id]
              : [],
        file_image: imageName || null,
        imagePreview: course_selected.image_url,
        video_url: course_selected.video_url,
        highlight: course_selected.highlight,
        visibility: VISIBILITY[course_selected.visibility],
        status: STATUS[course_selected.status],
        countries: course_selected.countries.map((country: any) => country.id),
        languages: course_selected.languages.map((language: any) => language.id),
        role: course_selected.role
      })
    }
  }, [course_selected])

  const handleMultiAutoCompleteChange = (inputName: string) => (_: any, value: any) => {
    let optionsMulti = []
    if (value !== null) {
      for (let i = 0; i < value.length; i++) {
        optionsMulti.push(value[i].id)
      }
    }
    setCourseState({ ...courseState, [inputName]: optionsMulti })
  }

  const handleInputChange = (inputName: string, value: any) => {
    setCourseState({ ...courseState, [inputName]: value })
  }

  return { handleInputChange, handleMultiAutoCompleteChange, courseState }
}

export default useCourseState
